// Treat URLs from saved settings/API responses as untrusted navigation targets.
export function getSafeWhatsappGroupUrl(value) {
  if (typeof value !== 'string' || value.length > 2048 || !value.trim()) return null;
  try {
    const candidate = value.trim();
    const raw = candidate.match(/^https:\/\/([^/?#]+)(\/[^?#]*)(?:\?[^#]*)?$/i);
    if (!raw || raw[1].includes('@')) return null;
    const url = new URL(candidate);
    if (url.protocol !== 'https:' || url.hostname !== 'chat.whatsapp.com'
      || url.username || url.password || url.port || url.hash
      || raw[2] !== url.pathname
      || !/^\/[A-Za-z0-9_-]{16,128}$/.test(url.pathname)) return null;
    return url.toString();
  } catch {
    return null;
  }
}